import WeissInsights from "./WeissInsights";

export default WeissInsights;